import { createContext, PropsWithChildren, useContext, useEffect, useRef } from 'react';
import { Channel, useChannelContext } from 'scbk-services';
import type { RemoteIdvCheckInfo, RemoteIdvCheckParam } from 'scbk-shared-module';
import { RemoteIdvCheckComponent, usePopup } from 'scbk-shared-module';

interface ContextProps {
  openAuthPop: (initParam: RemoteIdvCheckParam) => {};
}

const PhoneAuthContext = createContext<ContextProps>({
  openAuthPop: () => {
    return {} as RemoteIdvCheckInfo;
  },
});

export const usePhoneAuthContext = () => useContext(PhoneAuthContext);

export const PhoneAuthProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { channel } = useChannelContext();
  const remoteIdvCheckPop = usePopup('RemoteIdvCheckComponent');
  const resolveRef = useRef<any>(undefined);
  const params = useRef<RemoteIdvCheckParam>({ bizType: '' });

  useEffect(() => {
    if (!resolveRef.current) {
      resolveRef.current = undefined;
    }
  }, []);

  /**
   *
   * @param initParam
   * @returns
   */
  const openPopup = async (initParam: RemoteIdvCheckParam) => {
    params.current = initParam;
    remoteIdvCheckPop.setTrigger();
    remoteIdvCheckPop.open();

    return new Promise((resolve) => {
      resolveRef.current = resolve;
    });
  };

  /**
   *
   * @param remoteIdvCheckInfo
   */
  const handleComplete = (remoteIdvCheckInfo: RemoteIdvCheckInfo) => {
    if (resolveRef.current) {
      remoteIdvCheckPop.close();
      resolveRef.current(remoteIdvCheckInfo);
    }
  };

  /**
   *
   */
  const handleCancel = () => {
    if (resolveRef.current) {
      remoteIdvCheckPop.close();
      resolveRef.current(undefined);
    }
  };

  //인뱅인경우
  if (channel === Channel.IB) {
    return <>{children}</>;
  }

  return (
    <PhoneAuthContext.Provider value={{ openAuthPop: openPopup }}>
      {children}
      {/* 추가인증 팝업 오픈 */}
      {remoteIdvCheckPop.isOpen && (
        <RemoteIdvCheckComponent
          isOpen={remoteIdvCheckPop.isOpen}
          setOpen={remoteIdvCheckPop.setOpen}
          initParam={{ ...params.current }}
          onComplete={(remoteIdvCheckInfo: RemoteIdvCheckInfo) =>
            handleComplete(remoteIdvCheckInfo)
          }
          onClose={() => handleCancel()}
        />
      )}
    </PhoneAuthContext.Provider>
  );
};
